import React from "react";

const FilterInput = ({ placeholder, value, onChange }) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      className="border text-[#76A140] placeholder-[#76A140] border-[#76A140] rounded-md h-[40px] w-[150px] md:w-[212px] font-itcmedium text-[14px] px-4 py-2 focus:outline-none"
      value={value}
      onChange={onChange}
    />
  );
};

export default FilterInput;
